import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalFunctions } from '@global/GlobalFunctions';


export interface nsISystem {
	id: string;
	description: string;
	invoiceAddress: any;
	predefinedEventTags: string[]
	name: string
	customerNumber: any[]
	confirmedCustomer: boolean
	image: string
	tagGroups: string[]
	objectViews: any[]
	users: string[]
	tags: string[]
	admin: string[]
	alerts: string[]
	onlineDevices: any

}

export interface nsPostIntegration {

	headers: { [key: string]: string };
	sensors: any[];
	system: string;
	name: string;
	body: any;
	type: string;
	endpoint: string;
	disabled: number;
	id: string;
}

export interface nsWebhookConfig {

	name: string,
	body: {},
	sensors: any[],
	disabled: number,
	type: string,
	receivers: any[],
	created: number,
	endpoint: string,
	headers: { [key: string]: string };
	updated: number,
	system: string,
	id: string
}


export interface SensorPayload {
	type: string;
	sn: string;
	sample: SensorSample;
	config: SensorConfig;
	info: SensorInfo;
}

export interface SensorSample {
	sn: string;
	values: SensorValue[];
	time: number; // epoch millis
	rssi: number;
}

export interface SensorValue {
	index: number;
	unit: string;        // could be narrowed if you have a known enum set
	value: number;
	rawValue: number;
}

export interface SensorConfig {
	si: string[];
	desc: string;
	type: number;
	pv: number;
	calc: string[];
	iconUrl: string;
}

export interface SensorInfo {
	image: string;
	created: number;
	verified: number;
	registered: number;
	description: string;
	tags: string[];
	alias: string;
	sn: string;
	firmware: string;
	notifyOffline: NotifyOfflineConfig;
}

export interface NotifyOfflineConfig {
	enabled: boolean;
	subscribers: string[];
	users: string[];
}

@Injectable({
	providedIn: 'root'
})
export class NeuronsensorsService {

	/**
		 * Default Constructor
		 * @param http Imports the 'HttpClient' Object for internet requests
		 * @param globalFunctions Global Functions
		 */
	constructor(
		private http: HttpClient,
		public globalFunctions: GlobalFunctions
	) { }

	/**
	 * getSystems
	 * @param apiKey
	 * @param systemId
	 * @returns
	 */
	getSystems$(apiKey: string, systemId: string = "") {

		let routeURL = "https://api.neuronsensors.app/v2/systems";

		if (systemId != "") { routeURL = `${routeURL}/${systemId}` }
		return this.globalFunctions.fetchNeuronSensorAPI(this.http, routeURL, apiKey, "GET", {});

	}

	/**
	 * getIntegrations
	 * @param apiKey
	 * @param systemId
	 * @param id
	 * @returns
	 */
	getIntegrations$(apiKey: string, systemId: string, id: string = "") {
		let routeURL = `https://api.neuronsensors.app/v2/systems/${systemId}/integrations`;
		if (id != "") {
			{ routeURL = `${routeURL}/${id}` }
		} else {
			routeURL = routeURL + "?filter=REST&filter=POST&filter=AGRILOGG&filter=OSISOFT";
		}
		return this.globalFunctions.fetchNeuronSensorAPI(this.http, routeURL, apiKey, "GET", {});

	}

	/**
	 * getIntegrationByType
	 * @param apiKey
	 * @param systemId
	 * @param filter
	 * @returns
	 */
	getIntegrationByType$(apiKey: string, systemId: string, filter: string[]) {
		let routeURL = `https://api.neuronsensors.app/v2/systems/${systemId}/integrations`;
		if (filter.length > 0) {
			const query = filter.map(f => `filter=${encodeURIComponent(f)}`).join("&");
			routeURL += `?${query}`;
		}
		return this.globalFunctions.fetchNeuronSensorAPI(this.http, routeURL, apiKey, "GET", {});

	}

	/**
	 * getIntegrationByID
	 * @param apiKey
	 * @param systemId
	 * @param ID
	 * @returns
	 */
	getIntegrationByID$(apiKey: string, systemId: string, ID: string) {
		let routeURL = `https://api.neuronsensors.app/v2/systems/${systemId}/integrations/${ID}`;

		return this.globalFunctions.fetchNeuronSensorAPI(this.http, routeURL, apiKey, "GET", {});

	}


	/**
	 * postIntegration
	 * @param apiKey
	 * @param systemId
	 * @param integraton
	 * @returns
	 */
	postIntegration$(apiKey: string, systemId: string, integraton: nsWebhookConfig) {
		let data = JSON.stringify(integraton);
		let routeURL = `https://api.neuronsensors.app/v2/systems/${systemId}/integrations`;
		return this.globalFunctions.fetchNeuronSensorAPI(this.http, routeURL, apiKey, "POST", data);
	}

	/**
	 * postIntegration
	 * @param apiKey
	 * @param systemId
	 * @param integraton
	 * @returns
	 */
	patchIntegration$(apiKey: string, systemId: string, integraton: nsWebhookConfig) {
		let data = JSON.stringify(integraton);
		let routeURL = `https://api.neuronsensors.app/v2/systems/${systemId}/integrations/${integraton.id}`;
		return this.globalFunctions.fetchNeuronSensorAPI(this.http, routeURL, apiKey, "PATCH", data);
	}

	/**
	 * getDDevice
	 * @param apiKey
	 * @param systemId
	 * @param filter
	 * @returns
	 */
	getDDevice$(apiKey: string, systemId: string, sn: string) {

		const routeURL = `https://api.neuronsensors.app/v2/systems/${systemId}/devices${sn ? `?sn=${sn}` : ''}`;

		return this.globalFunctions.fetchNeuronSensorAPI(this.http, routeURL, apiKey, "GET", {});

	}

}
